import { IApplicationState } from '../../types/redux';

export const developerValuationDataFetching = (state: IApplicationState): boolean => {
  return state.developerValuation.isFetching;
};
